exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".styles--cardTab__1Dbrn{display:inline-block;padding-top:17px;padding-bottom:14px;padding-left:4px;padding-right:4px;margin-right:14px;font-size:14px;cursor:pointer;border-bottom:3px solid transparent;margin-bottom:-1px}.styles--cardTab__1Dbrn:last-child{margin-right:0 !important}@media screen and (max-width: 767px){.styles--cardTab__1Dbrn{margin-right:8px;padding-right:1px;padding-left:1px;font-size:13px}}.block_title .styles--cardTab__1Dbrn{padding:20px 7px 18px 7px;font-size:15px;font-weight:600}.styles--tabLink__O5Q3X{text-decoration:none}.block_title .styles--active__OzH8v{padding-bottom:17px}\n", ""]);

// exports
exports.locals = {
	"cardTab": "styles--cardTab__1Dbrn",
	"tabLink": "styles--tabLink__O5Q3X",
	"active": "styles--active__OzH8v"
};